import './vendor.ts';

import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2Webstorage } from 'ngx-webstorage';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeFr);
registerLocaleData(localeEs);

import {
    JYoguiSharedModule,
    UserRouteAccessService,
    CustomDateParserFormatterI18n,
    CustomDatepickerI18n
} from './shared';
import { JYoguiHomeModule } from './home/home.module';
import { JYoguiAdminModule } from './admin/admin.module';
import { JYoguiAccountModule } from './account/account.module';
import { JYoguiEntityModule } from './entities/entity.module';
import { JYoguiMaintenanceModule } from './maintenance/maintenance.module';

import { JYoguiDashboardModule } from './dashboard/dashboard.module';
import { JYoguiCardDashboardTodayModule } from './card-dashboard-today/card-dashboard-today.module';
import { JYoguiUsersFinantialStatusReportModule } from './users-finantial-status-report/users-finantial-status-report-component.module';
import { JYoguiLessonsByInstructorReportModule } from './lessons-by-instructor-report/lessons-by-instructor-report-component.module';

import { LayoutRoutingModule } from './layouts';
import { PaginationConfig } from './blocks/config/uib-pagination.config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { InterceptorFactory } from './blocks/http/interceptor/interceptor-factory';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import {
    JhiMainComponent,
    NavbarComponent,
    FooterComponent,
    ProfileService,
    PageRibbonComponent,
    ActiveMenuDirective,
    ErrorComponent
} from './layouts';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        LayoutRoutingModule,
        Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
        JYoguiSharedModule,
        JYoguiHomeModule,
        JYoguiAdminModule,
        JYoguiAccountModule,
        JYoguiDashboardModule,
        JYoguiCardDashboardTodayModule,
        JYoguiUsersFinantialStatusReportModule,
        JYoguiLessonsByInstructorReportModule,
        JYoguiEntityModule,
        JYoguiMaintenanceModule
    ],
    declarations: [
        JhiMainComponent,
        NavbarComponent,
        ErrorComponent,
        PageRibbonComponent,
        ActiveMenuDirective,
        FooterComponent
    ],
    providers: [
        ProfileService,
        { provide: Window, useValue: window },
        { provide: Document, useValue: document },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatterI18n },
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: (factory: InterceptorFactory) => factory.createAuthInterceptor(),
            deps: [InterceptorFactory],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: (factory: InterceptorFactory) => factory.createAuthExpiredInterceptor(),
            deps: [InterceptorFactory],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: (factory: InterceptorFactory) => factory.createNotificationInterceptor(),
            deps: [InterceptorFactory],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: (factory: InterceptorFactory) => factory.createErrorHandlerInterceptor(),
            deps: [InterceptorFactory],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: (factory: InterceptorFactory) => factory.createMaintenanceInterceptor(),
            deps: [InterceptorFactory],
            multi: true,
        },
        InterceptorFactory,
        PaginationConfig,
        UserRouteAccessService,
        DatePipe
    ],
    bootstrap: [JhiMainComponent]
})
export class JYoguiAppModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts